import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { LessonsSubRoute } from "./Constants/routes";

const Lesson = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {LessonsSubRoute.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/lessons" />
      </Switch>
    </>
  );
};

export default Lesson;
